<template>
  <div class="management container">
    <!-- <b-button @click="test()">Test function[update followup reports]</b-button> -->
    <b-button @click="sendOverdueReminder()">sendOverdueReminder</b-button>
    <b-button @click="sendFollowUpReminder()">sendFollowUpReminder</b-button>
    <h1>Management</h1>
    <div>
      <b-tabs content-class="mt-3">
        <b-tab title="Staff" active>
          <b-form-group label="Filter:" label-for="filterCriteria">
            <b-input-group>
              <b-form-input type="text" id="filterCriteria1" v-model="filterCriteria" class="form-control" placeholder="Type to search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" @click="cleanFilterInfo"><b-icon icon="x-circle" variant="white"></b-icon></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-button v-b-modal.modal-create-staff variant="primary">Add a staff</b-button>
          <b-table @row-clicked="myRowClickHandler" class="mt-3" striped :fields="staff_fields" hover :items="staffs" :filter="filterCriteria"></b-table>
        </b-tab>

        <b-tab title="Store Locations">
          <b-form-group label="Filter:" label-for="filterCriteria">
            <b-input-group>
              <b-form-input type="text" id="filterCriteria2" v-model="filterCriteria" class="form-control" placeholder="Type to search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" @click="cleanFilterInfo"><b-icon icon="x-circle" variant="white"></b-icon></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-button v-b-modal.modal-create-store-location variant="primary">Add a store locations</b-button>
          <b-table @row-clicked="myRowClickHandler" class="mt-3" striped :fields="store_location_fields" hover :items="store_locations" :filter="filterCriteria"></b-table>
        </b-tab>

        <b-tab title="Cemetery">
          <b-form-group label="Filter:" label-for="filterCriteria">
            <b-input-group>
              <b-form-input type="text" id="filterCriteria3" v-model="filterCriteria" class="form-control" placeholder="Type to search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" @click="cleanFilterInfo"><b-icon icon="x-circle" variant="white"></b-icon></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-button v-b-modal.modal-create-cemetery variant="primary">Add a cemetery</b-button>
          <b-table @row-clicked="myRowClickHandler" :filter="filterCriteria" class="mt-3" striped :fields="cemetery_fields" hover :items="cemeteries"></b-table>
        </b-tab>

        <b-tab title="Funeral Providers">
          <b-form-group label="Filter:" label-for="filterCriteria">
            <b-input-group>
              <b-form-input type="text" id="filterCriteria3" v-model="filterCriteria" class="form-control" placeholder="Type to search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" @click="cleanFilterInfo"><b-icon icon="x-circle" variant="white"></b-icon></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-button v-b-modal.modal-create-funeral-provider variant="primary">Add a funeral provider</b-button>
          <b-table @row-clicked="myRowClickHandler" :filter="filterCriteria" class="mt-3" striped :fields="funeral_providers_fields" hover :items="funeral_providers">
            <template #cell(action)="row">
              <b-row style="min-width: 200px">
                <b-button variant="outline-warning" @click="editRow(row.item, 'funeral_provider')">Edit</b-button>
                <b-button class="ml-1" variant="outline-danger" @click="deleteRow(row.item, 'funeral_providers')">Delete</b-button>
              </b-row>
            </template>
          </b-table>
        </b-tab>

        <b-tab title="Job Style">
          <b-form-group label="Filter:" label-for="filterCriteria">
            <b-input-group>
              <b-form-input type="text" id="filterCriteria4" v-model="filterCriteria" class="form-control" placeholder="Type to search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" @click="cleanFilterInfo"><b-icon icon="x-circle" variant="white"></b-icon></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-button v-b-modal.modal-create-job-style variant="primary">Add a job style</b-button>
          <b-table @row-clicked="myRowClickHandler" :filter="filterCriteria" class="mt-3" striped :fields="job_style_fields" hover :items="job_styles"></b-table>
        </b-tab>
        
        <b-tab title="IP List">
          <b-form-group label="Filter:" label-for="filterCriteria">
            <b-input-group>
              <b-form-input type="text" id="filterCriteria5" v-model="filterCriteria" class="form-control" placeholder="Type to search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" @click="cleanFilterInfo"><b-icon icon="x-circle" variant="white"></b-icon></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-button v-b-modal.modal-create-ip variant="primary">Register an IP</b-button>
          <b-table @row-clicked="myRowClickHandler" :filter="filterCriteria" class="mt-3" striped :fields="ip_fields" hover :items="iPs"></b-table>
        </b-tab>

        <b-tab v-if="this.user.name == 'Rick' || this.user.name == 'Liz' || this.user.name == 'Jacky'" title="Quotation">
          <b-tabs content-class="mt-3">
            <b-tab title="Monument">
              <b-form-group label="Filter:" label-for="filterCriteria">
                <b-input-group>
                  <b-form-input type="text" id="filterCriteria6" v-model="filterCriteria" class="form-control" placeholder="Type to search"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" @click="cleanFilterInfo"><b-icon icon="x-circle" variant="white"></b-icon></b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <b-row align-h="between">
                <b-col cols="4">
                  <b-button v-b-modal.modal-create-monument variant="primary">Create a monument</b-button>
                </b-col>
                <b-col class="text-right" cols="5">
                  <label>Percentage:</label>
                  <div class="ml-1" style="display: inline-block">
                    <input type="text"
                      v-model="monument_discount"
                      class="form-control">
                  </div>
                  <p class="mx-1" style="display: inline-block">%</p>
                  <b-button variant="primary" style="display: inline-block" @click="updateMonumentDiscount">Apply</b-button>
                </b-col>
              </b-row>
              <b-table @row-clicked="myRowClickHandler" :filter="filterCriteria" class="mt-3" striped :fields="monument_fields" hover :items="monuments">
                <template #cell(price)="row">
                  <div v-for="(element, index) in row.item.priceAndSize" :key="'price' + index">
                    {{element.size}}: ${{element.price * monument_discount / 100}}
                  </div>
                </template>

                <template #cell(action)="row">
                  <b-row style="min-width: 200px">
                    <b-button variant="outline-warning" @click="editRow(row.item, 'monument')">Edit</b-button>
                    <b-button class="ml-1" variant="outline-danger" @click="deleteRow(row.item, 'monuments')">Delete</b-button>
                  </b-row>
                </template>
              </b-table>
            </b-tab>

            <b-tab title="Installation">
              <b-form-group label="Filter:" label-for="filterCriteria">
                <b-input-group>
                  <b-form-input type="text" id="filterCriteria7" v-model="filterCriteria" class="form-control" placeholder="Type to search"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" @click="cleanFilterInfo"><b-icon icon="x-circle" variant="white"></b-icon></b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <b-button v-b-modal.modal-create-installation variant="primary">Create a installation</b-button>
              <b-table @row-clicked="myRowClickHandler" :filter="filterCriteria" class="mt-3" striped :fields="installation_fields" hover :items="installations">
                <template #cell(price)="row">
                  ${{row.item.price}}
                </template>

                <template #cell(action)="row">
                  <b-row style="min-width: 200px">
                    <b-button variant="outline-warning" @click="editRow(row.item, 'installation')">Edit</b-button>
                    <b-button class="ml-1" variant="outline-danger" @click="deleteRow(row.item, 'installations')">Delete</b-button>
                  </b-row>
                </template>
              </b-table>
            </b-tab>

            <b-tab title="Carving">
              <b-form-group label="Filter:" label-for="filterCriteria">
                <b-input-group>
                  <b-form-input type="text" id="filterCriteria8" v-model="filterCriteria" class="form-control" placeholder="Type to search"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" @click="cleanFilterInfo"><b-icon icon="x-circle" variant="white"></b-icon></b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <b-button v-b-modal.modal-create-casting variant="primary">Create a casting</b-button>
              <b-table @row-clicked="myRowClickHandler" :filter="filterCriteria" class="mt-3" striped :fields="casting_fields" hover :items="castings">
                <template #cell(price)="row">
                  ${{row.item.price}}
                </template>

                <template #cell(action)="row">
                  <b-row style="min-width: 200px">
                    <b-button variant="outline-warning" @click="editRow(row.item, 'casting')">Edit</b-button>
                    <b-button class="ml-1" variant="outline-danger" @click="deleteRow(row.item, 'castings')">Delete</b-button>
                  </b-row>
                </template>
              </b-table>
            </b-tab>

            <b-tab title="Inscription">
              <b-form-group label="Filter:" label-for="filterCriteria">
                <b-input-group>
                  <b-form-input type="text" id="filterCriteria9" v-model="filterCriteria" class="form-control" placeholder="Type to search"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" @click="cleanFilterInfo"><b-icon icon="x-circle" variant="white"></b-icon></b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <b-button v-b-modal.modal-create-inscription variant="primary">Create a inscription</b-button>
              <b-table @row-clicked="myRowClickHandler" :filter="filterCriteria" class="mt-3" striped :fields="inscription_fields" hover :items="inscriptions">
                <template #cell(name)="row">
                  <div style="max-width: 400px">{{row.item.name}}</div>
                </template>
                
                <template #cell(price)="row">
                  ${{row.item.price}}
                </template>

                <template #cell(action)="row">
                  <b-row style="min-width: 200px">
                    <b-button variant="outline-warning" @click="editRow(row.item, 'inscription')">Edit</b-button>
                    <b-button class="ml-1" variant="outline-danger" @click="deleteRow(row.item, 'inscriptions')">Delete</b-button>
                  </b-row>
                </template>
              </b-table>
            </b-tab>

            <b-tab title="Foundation">
              <b-form-group label="Filter:" label-for="filterCriteria">
                <b-input-group>
                  <b-form-input type="text" id="filterCriteria10" v-model="filterCriteria" class="form-control" placeholder="Type to search"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" @click="cleanFilterInfo"><b-icon icon="x-circle" variant="white"></b-icon></b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <b-button v-b-modal.modal-create-foundation variant="primary">Create a foundation</b-button>
              <b-table @row-clicked="myRowClickHandler" :filter="filterCriteria" class="mt-3" striped :fields="foundation_fields" hover :items="foundations">
                <template #cell(price)="row">
                  ${{row.item.price}}
                </template>

                <template #cell(action)="row">
                  <b-row style="min-width: 200px">
                    <b-button variant="outline-warning" @click="editRow(row.item, 'foundation')">Edit</b-button>
                    <b-button class="ml-1" variant="outline-danger" @click="deleteRow(row.item, 'foundations')">Delete</b-button>
                  </b-row>
                </template>
              </b-table>
            </b-tab>

            <b-tab title="Accessories">
              <b-form-group label="Filter:" label-for="filterCriteria">
                <b-input-group>
                  <b-form-input type="text" id="filterCriteria11" v-model="filterCriteria" class="form-control" placeholder="Type to search"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" @click="cleanFilterInfo"><b-icon icon="x-circle" variant="white"></b-icon></b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <b-button v-b-modal.modal-create-accessory variant="primary">Create an accessory</b-button>
              <b-table @row-clicked="myRowClickHandler" :filter="filterCriteria" class="mt-3" striped :fields="accessory_fields" hover :items="accessories">
                <template #cell(description)="row">
                  <p v-if="row.item.description.length == 0">N/A</p>
                  {{ row.item.description }}
                </template>

                <template #cell(price)="row">
                  <div v-for="(element, index) in row.item.specAndPrice" :key="'spec_and_price' + index">
                    {{element.spec}}: ${{element.price}}
                  </div>
                </template>

                <template #cell(action)="row">
                  <b-row style="min-width: 200px">
                    <b-button variant="outline-warning" @click="editRow(row.item, 'accessory')">Edit</b-button>
                    <b-button class="ml-1" variant="outline-danger" @click="deleteRow(row.item, 'accessories')">Delete</b-button>
                  </b-row>
                </template>
              </b-table>
            </b-tab>

            <b-tab title="Lead Source">
              <b-form-group label="Filter:" label-for="filterCriteria">
                <b-input-group>
                  <b-form-input type="text" id="filterCriteria11" v-model="filterCriteria" class="form-control" placeholder="Type to search"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" @click="cleanFilterInfo"><b-icon icon="x-circle" variant="white"></b-icon></b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <b-button v-b-modal.modal-create-lead-source variant="primary">Create a new lead source</b-button>
              <b-table @row-clicked="myRowClickHandler" :filter="filterCriteria" class="mt-3" striped :fields="lead_source_fields" hover :items="lead_sources">
                <template #cell(action)="row">
                  <b-row style="min-width: 200px">
                    <b-button variant="outline-warning" @click="editRow(row.item, 'lead_source')">Edit</b-button>
                    <b-button class="ml-1" variant="outline-danger" @click="deleteRow(row.item, 'lead_sources')">Delete</b-button>
                  </b-row>
                </template>
              </b-table>
            </b-tab>
          </b-tabs>
        </b-tab>

        <b-tab title="Supplier">
          <b-form-group label="Filter:" label-for="filterCriteria">
            <b-input-group>
              <b-form-input type="text" id="filterCriteria11" v-model="filterCriteria" class="form-control" placeholder="Type to search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" @click="cleanFilterInfo"><b-icon icon="x-circle" variant="white"></b-icon></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-button v-b-modal.modal-add-supplier variant="primary">Add supplier</b-button>
          <b-table class="pointer mt-2" 
            :filter="filterCriteria" 
            @row-clicked="supplier_row_click_handler" 
            responsive
            striped
            hover
            small
            :fields="supplier_fields"
            :items="suppliers">
          </b-table>
        </b-tab>
      </b-tabs>
    </div>

    <!-- CREATE ROWS -->

    <b-modal id="modal-create-staff" hide-footer title="Add a staff">
      <label for="staff_email">Email:</label>
      <input type="text" 
        id="staff_email" 
        v-model="staff.staff_email" 
        class="form-control">

      <label for="staff_password">Password:</label>
      <input type="text" 
        id="staff_password" 
        v-model="staff.staff_password" 
        class="form-control">

      <label for="staff_name">Name:</label>
      <input type="text" 
        id="staff_name" 
        v-model="staff.staff_name" 
        class="form-control">

      <label for="staff_role">Role:</label>
      <b-form-select 
        v-model="staff.staff_role" 
        :options="staff_roles"></b-form-select>

      <div class="modal-footer">
        <b-button @click="hideModal('modal-create-staff')"> Cancel </b-button>
        <b-button @click="createStaff()" variant="primary">Create</b-button>
      </div>
    </b-modal>

    <b-modal id="modal-create-cemetery" hide-footer title="Add a cemetery">
      <label for="cemetery_name">Name:</label>
      <input type="text" 
        id="cemetery_name" 
        v-model="cemetery_name" 
        class="form-control">

      <div class="modal-footer">
        <b-button @click="hideModal('modal-create-cemetery')"> Cancel </b-button>
        <b-button @click="createCemetery()" variant="primary">Create</b-button>
      </div>
    </b-modal>

    <b-modal id="modal-create-funeral-provider" hide-footer title="Add a funeral provider">
      <label for="funeralProviderName">Name:</label>
      <input type="text" 
        id="funeralProviderName" 
        v-model="funeralProviderName" 
        class="form-control"
        v-on:keyup.enter="createFuneralProvider()">

      <div class="modal-footer">
        <b-button @click="hideModal('modal-create-funeral-provider')"> Cancel </b-button>
        <b-button @click="createFuneralProvider()" variant="primary">Create</b-button>
      </div>
    </b-modal>

    <b-modal id="modal-edit-funeral-provider" hide-footer title="Edit a funeral provider">
      <label for="eidted_funeralProviderName">Name:</label>
      <input type="text" 
        id="eidted_funeralProviderName" 
        v-model="editedFuneralProvider.name" 
        class="form-control"
        v-on:keyup.enter="editFuneralProvider()">

      <div class="modal-footer">
        <b-button @click="hideModal('modal-edit-funeral-provider')"> Cancel </b-button>
        <b-button @click="editFuneralProvider()" variant="primary"> Enter </b-button>
      </div>
    </b-modal>

    <b-modal id="modal-create-job-style" hide-footer title="Add a job style">
      <label for="job_style.name">Name:</label>
      <input type="text" 
        id="job_style.name" 
        v-model="job_style.name" 
        class="form-control">

      <div class="modal-footer">
        <b-button @click="hideModal('modal-create-job-style')"> Cancel </b-button>
        <b-button @click="createJobStyle()" variant="primary">Create</b-button>
      </div>
    </b-modal>

    <b-modal id="modal-create-ip" hide-footer title="Register a ip">
      <label for="ip_name">Name:</label>
      <input type="text" 
        id="ip_name" 
        v-model="ip_name" 
        class="form-control">

      <label for="ip_ip">IP:</label>
      <input type="text" 
        id="ip_ip" 
        v-model="ip_ip" 
        class="form-control">
      <div class="modal-footer">
        <b-button @click="hideModal('modal-create-ip')"> Cancel </b-button>
        <b-button @click="registerIP()" variant="primary">Create</b-button>
      </div>
    </b-modal>

    <b-modal id="modal-create-store-location" hide-footer title="Create a store location">
      <label for="form_store_location_name">Name:</label>
      <input type="text" 
        id="form_store_location_name" 
        v-model="form_store_location.name" 
        class="form-control">

      <label for="form_store_location_street">Street:</label>
      <input type="text" 
        id="form_store_location_street" 
        v-model="form_store_location.street" 
        class="form-control">

      <label for="form_store_location_state">State & Postcode:</label>
      <input type="text" 
        id="form_store_location_state" 
        v-model="form_store_location.state" 
        class="form-control">

      <label for="form_store_location_name">Phone:</label>
      <input type="text" 
        id="form_store_location_phone" 
        v-model="form_store_location.phone" 
        class="form-control">

      <label for="form_store_location_fax">Fax:</label>
      <input type="text"
        id="form_store_location_fax"
        v-model="form_store_location.fax" 
        class="form-control">

      <div class="modal-footer">
        <b-button @click="hideModal('modal-create-store-location')"> Cancel </b-button>
        <b-button @click="createStoreLocation()" variant="primary">Create</b-button>
      </div>
    </b-modal>

    <b-modal id="modal-create-monument" hide-footer title="Create a monument">
      <b-form @submit.prevent="createMonument">
        <label for="monument_english_name">English Name:</label>
        <input type="text"
          id="monument_english_name"
          v-model="newMonument.english_name"
          class="form-control"
          required>

        <label for="monument_chinese_name">Chinese Name:</label>
        <input type="text"
          id="monument_chinese_name"
          v-model="newMonument.chinese_name"
          class="form-control"
          required>

        <label for="monument_color">Color:</label>
        <input type="text" 
          id="monument_color" 
          v-model="newMonument.color"
          class="form-control"
          required>

        <label for="monument_origin">Origin:</label>
        <input type="text" 
          id="monument_origin" 
          v-model="newMonument.origin" 
          class="form-control"
          required>

        <div class="mt-2 mb-4">
          <label>Price and Size:</label>
          <b-icon class="ml-2" icon="plus-circle" scale="1.5" variant="primary" @click="addPriceAndSize"></b-icon>
          <div v-for="(element, index) in this.newMonument.priceAndSize" :key="'price_and_size' + index">
            <b-row align-v="center">
              <b-col>
                <label>Size:</label>
                <b-form-select 
                  v-model="newMonument.priceAndSize[index].size" 
                  :options="monument_sizes"
                  :required = true></b-form-select>
              </b-col>

              <b-col>
                <label>Price:</label>
                <input type="text" 
                  v-model="newMonument.priceAndSize[index].price" 
                  class="form-control"
                  required>
              </b-col>

              <b-col cols="1">
                <b-icon class="mt-4" icon="x-circle" scale="1.5" variant="danger" @click="removePriceAndSize(index)"></b-icon>
              </b-col>
            </b-row>
          </div>
        </div>
        <div class="modal-footer">
          <b-button @click="hideModal('modal-create-monument')"> Cancel </b-button>
          <b-button type="submit" variant="primary">Create</b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-create-installation" hide-footer title="Create a installation">
      <b-form @submit.prevent="createInstallation">
        <label for="installtion_name">Name:</label>
        <b-input type="text" 
          id="installtion_name" 
          v-model="newInstallation.name" 
          required></b-input>

        <label for="installation_type">Type:</label>
        <b-input type="text" 
          id="installation_type" 
          v-model="newInstallation.type" 
          required></b-input>

        <label for="installation_price">Price:</label>
        <b-input type="number"
          id="installation_price" 
          v-model="newInstallation.price" 
          required></b-input>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-create-installation')"> Cancel </b-button>
          <b-button type="submit" variant="primary">Submit</b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-create-casting" hide-footer title="Create a casting">
      <b-form @submit.prevent="createCasting">
        <label for="casting_name">Name:</label>
        <b-input type="text" 
          id="casting_name" 
          v-model="newCasting.name" 
          required></b-input>

        <label for="casting_size">Size:</label>
        <b-input type="text" 
          id="casting_size" 
          v-model="newCasting.size" 
          required></b-input>

        <label for="casting_price">Price:</label>
        <b-input type="number"
          id="casting_price" 
          v-model="newCasting.price" 
          required></b-input>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-create-casting')"> Cancel </b-button>
          <b-button type="submit" variant="primary">Submit</b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-create-inscription" hide-footer title="Create a inscription">
      <b-form @submit.prevent="createInscription">
        <label for="inscription_name">Name:</label>
        <b-input type="text" 
          id="inscription_name" 
          v-model="newInscription.name" 
          required></b-input>

        <label for="inscription_type">Type:</label>
        <b-input type="text" 
          id="inscription_type" 
          v-model="newInscription.type" 
          required></b-input>

        <label for="inscription_price">Price:</label>
        <b-input type="text"
          id="inscription_price" 
          v-model="newInscription.price" 
          required></b-input>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-create-inscription')"> Cancel </b-button>
          <b-button type="submit" variant="primary">Submit</b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-create-accessory" hide-footer title="Create a accessory">
      <b-form @submit.prevent="createAccessory">
        <label for="accessory_name">Name:</label>
        <b-input type="text" 
          id="accessory_name" 
          v-model="newAccessory.name" 
          required></b-input>

        <label for="accessory_description">Description:</label>
        <b-form-textarea
          id="accessory_description"
          v-model="newAccessory.description"
          placeholder="Description..."
          rows="3"
          max-rows="3"></b-form-textarea>

        <label for="accessory_type">Type:</label>
        <b-input type="text" 
          id="accessory_type" 
          v-model="newAccessory.type" 
          required></b-input>

        <div class="mt-2 mb-4">
          <label>Spec and Price:</label>
          <b-icon class="ml-2" icon="plus-circle" scale="1.5" variant="primary" @click="addPriceAndSize"></b-icon>
          <div v-for="(element, index) in this.newAccessory.specAndPrice" :key="'spec_and_price' + index">
            <b-row align-v="center">
              <b-col>
                <label>Spec:</label>
                <input type="text" 
                  v-model="newAccessory.specAndPrice[index].spec" 
                  class="form-control"
                  required>
              </b-col>

              <b-col>
                <label>Price:</label>
                <input type="text"
                  v-model="newAccessory.specAndPrice[index].price" 
                  class="form-control"
                  required>
              </b-col>

              <b-col cols="1">
                <b-icon class="mt-4" icon="x-circle" scale="1.5" variant="danger" @click="removePriceAndSize(index)"></b-icon>
              </b-col>
            </b-row>
          </div>
        </div>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-create-accessory')"> Cancel </b-button>
          <b-button type="submit" variant="primary">Submit</b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-create-foundation" hide-footer title="Create a foundation">
      <b-form @submit.prevent="createFoundation">
        <label for="foundation_name">Name:</label>
        <b-input type="text" 
          id="foundation_name" 
          v-model="newFoundation.name" 
          required></b-input>

        <label for="foundation_description">Description:</label>
        <b-form-textarea
          id="foundation_description"
          v-model="newFoundation.description"
          placeholder="Description..."
          rows="3"
          max-rows="3"></b-form-textarea>

        <label for="foundation_price">Price:</label>
        <b-input type="text"
          id="foundation_price" 
          v-model="newFoundation.price" 
          required></b-input>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-create-foundation')"> Cancel </b-button>
          <b-button type="submit" variant="primary">Submit</b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-create-lead-source" hide-footer title="Create a lead source">
      <b-form @submit.prevent="createLeadSource">
        <label for="leader_source_name">Name:</label>
        <b-input type="text" 
          id="leader_source_name" 
          v-model="lead_source_name" 
          required></b-input>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-create-lead-source')"> Cancel </b-button>
          <b-button type="submit" variant="primary">Submit</b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-add-supplier" hide-footer title="Add supplier">
      <b-form @submit.prevent="add_supplier">
        <label for="supplier_category">Category:</label>
        <b-input type="text" 
          id="supplier_category" 
          v-model="new_supplier.category" 
          required></b-input>

        <label for="supplier_category">Name:</label>
        <b-input type="text" 
          id="supplier_name" 
          v-model="new_supplier.name" 
          required></b-input>

        <label for="supplier_category">Phone:</label>
        <b-input type="text" 
          id="supplier_phone" 
          v-model="new_supplier.phone" 
          ></b-input>

        <label for="supplier_category">Email:</label>
        <b-input type="text" 
          id="supplier_email" 
          v-model="new_supplier.email" 
          ></b-input>

        <br>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-add-supplier')"> Cancel </b-button>
          <b-button type="submit" variant="primary">Submit</b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- EDIT ROWS -->

    <b-modal id="modal-edit-monument" hide-footer title="Edit monument">
      <b-form @submit.prevent="editMonumentTask">
        <label for="monument_english_name">English Name:</label>
        <input type="text"
          id="monument_english_name"
          v-model="editedMonument.english_name"
          class="form-control"
          required>

        <label for="monument_chinese_name">Chinese Name:</label>
        <input type="text"
          id="monument_chinese_name"
          v-model="editedMonument.chinese_name"
          class="form-control"
          required>

        <label for="monument_color">Color:</label>
        <input type="text" 
          id="monument_color" 
          v-model="editedMonument.color"
          class="form-control"
          required>

        <label for="monument_origin">Origin:</label>
        <input type="text" 
          id="monument_origin" 
          v-model="editedMonument.origin" 
          class="form-control"
          required>

        <div class="mt-2 mb-4">
          <label>Price and Size:</label>
          <b-icon class="ml-2" icon="plus-circle" scale="1.5" variant="primary" @click="addPriceAndSizeToEditedMonument"></b-icon>
          <div v-for="(element, index) in this.editedMonument.priceAndSize" :key="'price_and_size' + index">
            <b-row align-v="center">
              <b-col>
                <label>Size:</label>
                <b-form-select 
                  v-model="editedMonument.priceAndSize[index].size" 
                  :options="monument_sizes"
                  :required = true></b-form-select>
              </b-col>

              <b-col>
                <label>Price:</label>
                <input type="text" 
                  v-model="editedMonument.priceAndSize[index].price" 
                  class="form-control"
                  required>
              </b-col>

              <b-col cols="1">
                <b-icon class="mt-4" icon="x-circle" scale="1.5" variant="danger" @click="removePriceAndSizeFromEditedMonument(index)"></b-icon>
              </b-col>
            </b-row>
          </div>
        </div>
        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-monument')"> Cancel </b-button>
          <b-button type="submit" variant="primary">Submit</b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-edit-installation" hide-footer title="Edit installation">
      <b-form @submit.prevent="editInstallationTask">
        <label for="installtion_name">Name:</label>
        <b-input type="text" 
          id="installtion_name" 
          v-model="editedInstallation.name" 
          required></b-input>

        <label for="installation_type">Type:</label>
        <b-input type="text" 
          id="installation_type" 
          v-model="editedInstallation.type" 
          required></b-input>

        <label for="installation_price">Price:</label>
        <b-input type="number"
          id="installation_price" 
          v-model="editedInstallation.price" 
          required></b-input>
        
        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-installation')"> Cancel </b-button>
          <b-button type="submit" variant="primary">Submit</b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-edit-casting" hide-footer title="Edit Casting">
      <b-form @submit.prevent="editCastingTask">
        <label for="casting_name">Name:</label>
        <b-input type="text" 
          id="casting_name" 
          v-model="editedCasting.name" 
          required></b-input>

        <label for="casting_type">Size:</label>
        <b-input type="text" 
          id="casting_type" 
          v-model="editedCasting.size" 
          required></b-input>

        <label for="casting_price">Price:</label>
        <b-input type="number"
          id="casting_price" 
          v-model="editedCasting.price" 
          required></b-input>
        
        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-casting')"> Cancel </b-button>
          <b-button type="submit" variant="primary">Submit</b-button>
        </div>
      </b-form>
    </b-modal>
    
    <b-modal id="modal-edit-inscription" hide-footer title="Edit Inscription">
      <b-form @submit.prevent="editInscriptionTask">
        <label for="inscription_name">Name:</label>
        <b-input type="text" 
          id="inscription_name" 
          v-model="editedInscription.name" 
          required></b-input>

        <label for="inscription_type">Type:</label>
        <b-input type="text" 
          id="inscription_type" 
          v-model="editedInscription.type" 
          required></b-input>

        <label for="inscription_price">Price:</label>
        <b-input
          id="inscription_price" 
          v-model="editedInscription.price" 
          required></b-input>
        
        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-inscription')"> Cancel </b-button>
          <b-button type="submit" variant="primary">Submit</b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-edit-foundation" hide-footer title="Edit foundation">
      <b-form @submit.prevent="editFoundationTask">
        <label for="foundation_name">Name:</label>
        <b-input type="text" 
          id="foundation_name" 
          v-model="editedFoundation.name" 
          required></b-input>

        <label for="foundation_description">Description:</label>
        <b-input type="text" 
          id="foundation_description" 
          v-model="editedFoundation.description" 
          ></b-input>

        <label for="foundation_price">Price:</label>
        <b-input type="number"
          id="foundation_price" 
          v-model="editedFoundation.price" 
          required></b-input>
        
        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-foundation')"> Cancel </b-button>
          <b-button type="submit" variant="primary">Submit</b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-edit-accessory" hide-footer title="Edit accessory">
      <b-form @submit.prevent="editAccessoryTask">
        <label for="accessory_name">Name:</label>
        <b-input type="text" 
          id="accessory_name" 
          v-model="editedAccessory.name" 
          required></b-input>

        <label for="accessory_description">Description:</label>
        <b-input type="text" 
          id="accessory_description" 
          v-model="editedAccessory.description" 
          ></b-input>

        <label for="accessory_type">Type:</label>
        <b-input type="text" 
          id="accessory_type" 
          v-model="editedAccessory.type" 
          required></b-input>

        <div class="mt-2 mb-4">
          <label>Spec and Price:</label>
          <b-icon class="ml-2" icon="plus-circle" scale="1.5" variant="primary" @click="addPriceAndSizeToEditedAccessory"></b-icon>
          <div v-for="(element, index) in this.editedAccessory.specAndPrice" :key="'price_and_size' + index">
            <b-row align-v="center">
              <b-col>
                <label>Spec:</label>
                <input type="text" 
                  v-model="editedAccessory.specAndPrice[index].spec" 
                  class="form-control"
                  required>
              </b-col>

              <b-col>
                <label>Price:</label>
                <input type="text" 
                  v-model="editedAccessory.specAndPrice[index].price" 
                  class="form-control"
                  required>
              </b-col>

              <b-col cols="1">
                <b-icon class="mt-4" icon="x-circle" scale="1.5" variant="danger" @click="removePriceAndSizeFromEditedAccessory(index)"></b-icon>
              </b-col>
            </b-row>
          </div>
        </div>
        
        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-accessory')"> Cancel </b-button>
          <b-button type="submit" variant="primary">Submit</b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-edit-lead-source" hide-footer title="Edit a lead source">
      <label for="eidted-lead-source-name">Name:</label>
      <input type="text" 
        id="eidted-lead-source-name" 
        v-model="editedLeadSource.name" 
        class="form-control"
        v-on:keyup.enter="editLeadSource()">

      <div class="modal-footer">
        <b-button @click="hideModal('modal-edit-lead-source')"> Cancel </b-button>
        <b-button @click="editLeadSource()" variant="primary"> Enter </b-button>
      </div>
    </b-modal>

    <b-modal id="modal-view-supplier" hide-footer title="View supplier">
      <b-form @submit.prevent="editSupplier">
        <label for="supplier_category">Category:</label>
        <b-input type="text" 
          id="supplier_category" 
          v-model="viewed_supplier.category" 
          required></b-input>

        <label for="supplier_category">Name:</label>
        <b-input type="text" 
          id="supplier_name" 
          v-model="viewed_supplier.name"
          required></b-input>

        <label for="supplier_category">Phone:</label>
        <b-input type="text" 
          id="supplier_phone" 
          v-model="viewed_supplier.phone"></b-input>

        <label for="supplier_category">Email:</label>
        <b-input type="text" 
          id="supplier_email" 
          v-model="viewed_supplier.email"></b-input>

        <br>

        <div class="modal-footer">
          <b-button class="ml-1" variant="outline-danger" @click="deleteRow(viewed_supplier, 'suppliers')">Delete</b-button>
          <b-button @click="hideModal('modal-view-supplier')"> Cancel </b-button>
          <b-button type="submit" variant="warning">Update</b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- DELETE ROWS -->
    <b-modal id="data-delete-confirmation" hide-footer title="You are deleting a row">
      <p>This row {{deletedRow.name}}{{deletedRow.english_name}} will be permanently deleted.</p>
      <div class="modal-footer">
        <b-button @click="hideModal('data-delete-confirmation')"> Cancel </b-button>
        <b-button variant="danger" @click="deleteRowTask"> Delete </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import firebase from 'firebase/app'

export default {
  name: "Management",
  props: {
    user: Object,
  },
  data() {
    return {
      editedSupplier: null,
      lead_sources: [],
      lead_source_name: "",
      editedLeadSource: "",
      lead_source_fields: [
        { key: 'name', label: 'Name'},
        { key: 'action', label: 'Action'},
      ],
      global_setting: null,
      monument_discount: 100,
      firestore: null,
      staff: {
        staff_email: '',
        staff_password: '',
        staff_name: '',
        staff_role: ''
      },
      cemetery_name: '',
      funeralProviderName: "",
      editedFuneralProvider: {},
      staffs: [],
      cemeteries: [],
      funeral_providers: [],
      store_locations: [],
      staff_fields: [
        { key: 'name', label: 'Name', sortDirection: 'asc' },
        { key: 'email', label: 'Email'},
        { key: 'role', label: 'Role'}
      ],
      store_location_fields: [
        { key: 'name', label: 'Name'},
        { key: 'street', label: 'Street'},
        { key: 'state', label: 'State'},
        { key: 'phone', label: 'Tel'},
        { key: 'fax', label: 'Fax'},
      ],
      cemetery_fields: [
        { key: 'name', label: 'Name', sortDirection: 'asc' }
      ],
      funeral_providers_fields: [
        { key: 'name', label: 'Name', sortDirection: 'asc' },
        { key: 'action', label: 'Action'},
      ],
      ip_fields: [
        { key: 'name', label: 'Name', sortDirection: 'asc' },
        { key: 'ip', label: 'IP'}
      ],
      staff_roles: [
        'sales',
        'worker',
        'admin'
      ],
      form_store_location: {
        name: '',
        street: '',
        state: '',
        phone: '',
        fax: ''
      },
      job_styles: [],
      job_style_fields: [
        {key: 'name', label: 'Name'},
      ],
      job_style: {
        name: '',
      },
      ip_name: '',
      ip_ip: '',
      iPs: [],
      monuments: [],
      newMonument: {
        english_name: '',
        chinese_name: '',
        color: '',
        origin: '',
        priceAndSize: [],
      },
      editedMonument: {
        english_name: '',
        chinese_name: '',
        color: '',
        origin: '',
        priceAndSize: [],
      },
      monument_sizes: [
        '0.15-0.35 Cubic',
        '0.35-0.91 Cubic',
        '0.91-1.7 Cubic'
      ],
      monument_fields: [
        { key: 'english_name', label: 'English Name'},
        { key: 'chinese_name', label: 'Chinese Name'},
        { key: 'color', label: 'Color'},
        { key: 'price', label: 'Price'},
        { key: 'action', label: 'Action'},
      ],
      installations: [],
      newInstallation: {
        id: '',
        name: '',
        type: '',
        price: 0,
      },
      editedInstallation: {
        id: '',
        name: '',
        type: '',
        price: 0,
      },
      installation_fields: [
        { key: 'name', label: 'Name'},
        { key: 'type', label: 'Type'},
        { key: 'price', label: 'Price'},
        { key: 'action', label: 'Action'},
      ],
      castings: [],
      newCasting: {
        id: '',
        name: '',
        size: '',
        price: 0,
      },
      editedCasting: {
        id: '',
        name: '',
        size: '',
        price: 0,
      },
      casting_fields: [
        { key: 'name', label: 'Name'},
        { key: 'size', label: 'Size'},
        { key: 'price', label: 'Price'},
        { key: 'action', label: 'Action'},
      ],
      inscriptions: [],
      newInscription: {
        name: '',
        type: '',
        price: 0,
      },
      editedInscription: {
        name: '',
        type: '',
        price: 0,
      },
      inscription_fields: [
        { key: 'name', label: 'Name'},
        { key: 'type', label: 'Type'},
        { key: 'price', label: 'Price'},
        { key: 'action', label: 'Action'},
      ],
      accessories: [],
      newAccessory: {
        name: '',
        description: '',
        type: '',
        specAndPrice: [],
      },
      editedAccessory: {
        name: '',
        description: '',
        type: '',
        specAndPrice: [],
      },
      accessory_fields: [
        { key: 'name', label: 'Name'},
        { key: 'description', label: 'Description'},
        { key: 'type', label: 'Type'},
        { key: 'price', label: 'Price'},
        { key: 'action', label: 'Action'},
      ],
      foundations: [],
      newFoundation: {
        name: '',
        description: '',
        price: 0,
      },
      editedFoundation: {
        name: '',
        description: '',
        price: 0,
      },
      foundation_fields: [
        { key: 'name', label: 'Name'},
        { key: 'description', label: 'Description'},
        { key: 'price', label: 'Price'},
        { key: 'action', label: 'Action'},
      ],
      suppliers: [],
      new_supplier: {
        category: '',
        name: '',
        phone: '',
        email: '',
      },
      viewed_supplier: {
        category: '',
        name: '',
        phone: '',
        email: '',
      },
      supplier_fields: [
        { key:'category', label: 'Category'},
        { key:'name', label: 'Name'},
        { key:'phone', label: 'Phone'},
        { key:'email', label: 'Email'},
      ],
      deletedRow: {},
      deleteFrom: '',
      filterCriteria: '',
    }
  },
  created() {
    this.firestore = firebase.firestore();
  },
  mounted() {
    this.firestore.collection('suppliers').orderBy('name').onSnapshot((collection) => {
      this.suppliers = collection.docs.map(doc => doc.data());
    });

    this.firestore.collection('lead_sources').orderBy('name').onSnapshot((collection) => {
      this.lead_sources = collection.docs.map(doc => doc.data());
    });
    
    this.firestore.collection('staffs').orderBy('name').onSnapshot((collection) => {
      this.staffs = collection.docs.map(doc => doc.data());
    });

    this.firestore.collection('cemeteries').orderBy('name').onSnapshot((collection) => {
      this.cemeteries = collection.docs.map(doc => doc.data());
    });

    this.firestore.collection('funeral_providers').orderBy('name').onSnapshot((collection) => {
      this.funeral_providers = collection.docs.map(doc => doc.data());
    });

    this.firestore.collection('job_styles').orderBy('name').onSnapshot((collection) => {
      this.job_styles = collection.docs.map(doc => doc.data());
    });

    this.firestore.collection('store_locations').orderBy('name').onSnapshot((collection) => {
      this.store_locations = collection.docs.map(doc => doc.data());
    });

    this.firestore.collection('ip').orderBy('name').onSnapshot((collection) => {
      this.iPs = collection.docs.map(doc => doc.data());
    });

    this.firestore.collection('monuments').orderBy('english_name').onSnapshot((collection) => {
      this.monuments = collection.docs.map(doc => doc.data());
    });

    this.firestore.collection('installations').orderBy('name').onSnapshot((collection) => {
      this.installations = collection.docs.map(doc => doc.data());
    });

    this.firestore.collection('castings').orderBy('name').onSnapshot((collection) => {
      this.castings = collection.docs.map(doc => doc.data());
    });

    this.firestore.collection('inscriptions').orderBy('name').onSnapshot((collection) => {
      this.inscriptions = collection.docs.map(doc => doc.data());
    });
    
    this.firestore.collection('accessories').orderBy('name').onSnapshot((collection) => {
      this.accessories = collection.docs.map(doc => doc.data());
    });

    this.firestore.collection('foundations').orderBy('name').onSnapshot((collection) => {
      this.foundations = collection.docs.map(doc => doc.data());
    });

    this.firestore.collection('global_settings').onSnapshot((collection) => {
      const settings = collection.docs.map(doc => doc.data());
      if (settings.length > 0) {
        this.global_setting = settings[0];
        this.monument_discount = this.global_setting.monument_discount;
      }
    });
  },
  methods: {
    myRowClickHandler(item) {
      console.log(item);
    },
    supplier_row_click_handler(item) {
      this.editRow(item, 'supplier');
    },
    registerIP() {
    var ipRef = this.firestore.collection("ip").doc();
    ipRef.set({
      name: this.ip_name,
      ip: this.ip_ip
    });
    this.$bvModal.hide('modal-create-ip');
      alert("Create successfully");
    },
    hideModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    createStoreLocation() {
      var storeLocationRef = this.firestore.collection("store_locations").doc();
      storeLocationRef.set({
      name: this.form_store_location.name,
        street: this.form_store_location.street,
        state: this.form_store_location.state,
        phone: this.form_store_location.phone,
        fax: this.form_store_location.fax,
      });

      this.$bvModal.hide('modal-create-store-location');
      alert("Create store location successfully");
      this.form_store_location = {
        name: '',
        street: '',
        state: '',
        phone: '',
        fax: ''
      };
    },
    createStaff() {
      var self = this;
      firebase.auth().createUserWithEmailAndPassword(this.staff.staff_email, this.staff.staff_password)
        .then(user => {
          var id = user.user.uid;
          console.log(id);
          console.log(user);

          var staffRef = this.firestore.collection("staffs").doc(id);
            staffRef.set({
              id: id,
              email: this.staff.staff_email,
              name: this.staff.staff_name,
              role: this.staff.staff_role
          });

          var userRef = this.firestore.collection("users").doc(id);
          userRef.set({
            id: id,
            email: this.staff.staff_email,
            name: this.staff.staff_name,
            role: this.staff.staff_role
          });

          var roleRef = this.firestore.collection(this.staff.staff_role + 's').doc(id);
          roleRef.set({
            id: id,
            email: this.staff.staff_email,
            name: this.staff.staff_name,
            role: this.staff.staff_role
          });

          self.$bvModal.hide('modal-create-staff');
          alert(id + "Create successfully");
        })
        .catch(error => {
            alert(error.message);
        });
    },
    createCemetery() {
      var cemeteryRef = this.firestore.collection("cemeteries").doc();
      cemeteryRef.set({
        id: cemeteryRef.id,
        name: this.cemetery_name
      });
      this.$bvModal.hide('modal-create-cemetery');
    },
    createFuneralProvider() {
      if (this.funeralProviderName.length > 0) {
        var funeralProviderRef = this.firestore.collection("funeral_providers").doc();
        funeralProviderRef.set({
          id: funeralProviderRef.id,
          name: this.funeralProviderName
        });

        this.funeralProviderName = "";
        this.$bvModal.hide('modal-create-funeral-provider');
      } else {
        alert("Name cannot be blank");
      }
    },
    createLeadSource() {
      var leadSourceRef = this.firestore.collection("lead_sources").doc();
      leadSourceRef.set({
        id: leadSourceRef.id,
        name: this.lead_source_name
      });

      this.lead_source_name = "";
      this.$bvModal.hide('modal-create-lead-source');
    },
    createJobStyle() {
      var jobStyleRef = this.firestore.collection("job_styles").doc();
      jobStyleRef.set({
        id: jobStyleRef.id,
        name: this.job_style.name,
      });
      this.$bvModal.hide('modal-create-job-style');
    },
    createMonument() {
      this.newMonument.priceAndSize.forEach((element) => {
        element.price = Number(element.price);
      });
      const monumentRef = this.firestore.collection('monuments').doc();
      monumentRef.set({
        id: monumentRef.id,
        english_name: this.newMonument.english_name,
        chinese_name: this.newMonument.chinese_name,
        color: this.newMonument.color,
        origin: this.newMonument.origin,
        priceAndSize: this.newMonument.priceAndSize,
      });
      this.newMonument = {
        id: '',
        english_name: '',
        chinese_name: '',
        color: '',
        origin: '',
        priceAndSize: [],
      }
      this.hideModal('modal-create-monument');
    },
    createInstallation() {
      this.newInstallation.price = Number(this.newInstallation.price);
      const installationsRef = this.firestore.collection('installations').doc();
      this.newInstallation.id = installationsRef.id;
      installationsRef.set(this.newInstallation);
      this.newInstallation = {
        id: '',
        name: '',
        type: '',
        price: 0,
      }
      this.hideModal('modal-create-installation');
    },
    createCasting() {
      this.newCasting.price = Number(this.newCasting.price);
      const castingRef = this.firestore.collection('castings').doc();
      this.newCasting.id = castingRef.id;
      castingRef.set(this.newCasting);
      this.newCasting = {
        id: '',
        name: '',
        size: '',
        price: 0,
      }
      this.hideModal('modal-create-casting');
    },
    createInscription() {
      this.newInscription.price = Number(this.newInscription.price);
      const inscriptionRef = this.firestore.collection('inscriptions').doc();
      this.newInscription.id = inscriptionRef.id;
      inscriptionRef.set(this.newInscription);
      this.newInscription = {
        id: '',
        name: '',
        type: '',
        price: 0,
      }
      this.hideModal('modal-create-inscription');
    },
    createAccessory() {
      this.newAccessory.specAndPrice.forEach((element) => {
        element.price = Number(element.price);
      });
      const accessoryRef = this.firestore.collection('accessories').doc();
      this.newAccessory.id = accessoryRef.id;
      accessoryRef.set(this.newAccessory);
      this.newAccessory = {
        name: '',
        description: '',
        type: '',
        specAndPrice: [],
      }
      this.hideModal('modal-create-accessory');
    },
    createFoundation() {
      this.newFoundation.price = Number(this.newFoundation.price);
      const foundationRef = this.firestore.collection('foundations').doc();
      this.newFoundation.id = foundationRef.id;
      foundationRef.set(this.newFoundation);
      this.newFoundation = {
        name: '',
        description: '',
        price: 0,
      }
      this.hideModal('modal-create-foundation');
    },
    add_supplier() {
      var supplier_ref = this.firestore.collection("suppliers").doc();
      this.new_supplier.id = supplier_ref.id;
      supplier_ref.set(this.new_supplier);

      this.new_supplier = {
        category: '',
        name: '',
        phone: '',
        email: '',
      };

      this.supplier_name = "";
      this.$bvModal.hide('modal-add-supplier');
    },
    addPriceAndSize() {
      this.newMonument.priceAndSize.push(
        {
          size: '',
          price: 0,
        }
      ),
      this.newAccessory.specAndPrice.push(
        {
          spec: '',
          price: 0,
        }
      )
    },
    addPriceAndSizeToEditedMonument() {
      this.editedMonument.priceAndSize.push(
        {
          size: '',
          price: 0,
        }
      )
    },
    addPriceAndSizeToEditedAccessory() {
      this.editedAccessory.specAndPrice.push(
        {
          spec: '',
          price: 0,
        }
      )
    },
    removePriceAndSize(index) {
      this.newMonument.priceAndSize.splice(index, 1);
      this.newAccessory.specAndPrice.splice(index, 1);
    },
    removeSpecAndPriceFromEditedMonument(index) {
      this.editedMonument.priceAndSize.splice(index, 1);
    },
    removePriceAndSizeFromEditedAccessory(index) {
      this.editedAccessory.specAndPrice.splice(index, 1);
    },
    changePriceToNumeric() {
      this.accessories.forEach((element) => {
        const ref = this.firestore.collection('accessories').doc(element.id);

        element.specAndPrice.forEach((content) => {
          content.price = Number(content.price);
        });

        ref.set(element);
      })
    },
    editRow(item, type) {
      switch (type) {
        case 'monument':
          this.editedMonument = item;
          this.showModal("modal-edit-monument");
          break;
        case 'installation':
          this.editedInstallation = item;
          this.showModal("modal-edit-installation");
          break;
        case 'casting':
          this.editedCasting = item;
          this.showModal("modal-edit-casting");
          break;
        case 'inscription':
          this.editedInscription = item;
          this.showModal("modal-edit-inscription");
          break;
        case 'foundation':
          this.editedFoundation = item;
          this.showModal("modal-edit-foundation");
          break;
        case 'accessory':
          this.editedAccessory = item;
          this.showModal("modal-edit-accessory");
          break;
        case 'funeral_provider':
          this.editedFuneralProvider = item;
          this.showModal("modal-edit-funeral-provider");
          break;
        case 'lead_source':
          this.editedLeadSource = item;
          this.showModal("modal-edit-lead-source");
          break;
        case 'supplier':
          this.viewed_supplier = item;
          this.showModal("modal-view-supplier");
          break;
      }
    },
    editSupplier() {
      const leadSourceRef = firebase.firestore().collection('suppliers').doc(this.viewed_supplier.id);
      leadSourceRef.set(this.viewed_supplier, {merge: true});
      this.hideModal("modal-view-supplier");
    },
    editLeadSource() {
      const leadSourceRef = firebase.firestore().collection('lead_sources').doc(this.editedLeadSource.id);
      leadSourceRef.set(this.editedLeadSource, {merge: true});
      this.hideModal("modal-edit-lead-source");
    },
    editFuneralProvider() {
      const funeralProviderRef = firebase.firestore().collection('funeral_providers').doc(this.editedFuneralProvider.id);
      funeralProviderRef.set(this.editedFuneralProvider, {merge: true});
      this.hideModal("modal-edit-funeral-provider");
    },
    editMonumentTask() {
      const monumentRef = firebase.firestore().collection('monuments').doc(this.editedMonument.id);
      monumentRef.set(this.editedMonument, {merge: true});
      this.hideModal("modal-edit-monument");
    },
    editInstallationTask() {
      const installationRef = firebase.firestore().collection('installations').doc(this.editedInstallation.id);
      installationRef.set(this.editedInstallation, {merge: true});
      this.hideModal("modal-edit-installation");
    },
    editInscriptionTask() {
      const inscriptionRef = firebase.firestore().collection('inscriptions').doc(this.editedInscription.id);
      inscriptionRef.set(this.editedInscription, {merge: true});
      this.hideModal("modal-edit-inscription");
    },
    editFoundationTask() {
      const foundationRef = firebase.firestore().collection('foundations').doc(this.editedFoundation.id);
      foundationRef.set(this.editedFoundation, {merge: true});
      this.hideModal("modal-edit-foundation");
    },
    editAccessoryTask() {
      const accessoryRef = firebase.firestore().collection('accessories').doc(this.editedAccessory.id);
      accessoryRef.set(this.editedAccessory, {merge: true});
      this.hideModal("modal-edit-accessory");
    },
    deleteRow(row, collection) {
      this.deletedRow = row;
      this.deleteFrom = collection;
      this.showModal('data-delete-confirmation');
    },
    deleteRowTask() {
      firebase.firestore().collection(this.deleteFrom).doc(this.deletedRow.id).delete();
      this.deleteFrom = '';
      this.deletedRow = {
        english_name: '',
        chinese_name: '',
        color: '',
        origin: '',
        priceAndSize: [],
      };
      this.hideModal('data-delete-confirmation');
      this.hideModal('modal-view-supplier');
    },
    cleanFilterInfo() {
      this.filterCriteria = "";
    },
    updateMonumentDiscount() {
      if (this.global_setting != null) {
        firebase.firestore().collection("global_settings").doc(this.global_setting.id).set(
          {
            monument_discount: this.monument_discount
          },
          {merge: true}
        )
      } else {
        console.log('update');
        const settingRef = firebase.firestore().collection("global_settings").doc();
        settingRef.set(
          {
            id: settingRef.id,
            monument_discount: this.monument_discount
          }
        );
      }

      alert("Update successfully!");
    },
    test() {
      firebase.firestore().collection("follow_up_reports")
      .get().then((collection) => {
        var rows = collection.docs.map(doc => doc.data());
        rows.forEach((e) => {
          if (e.job_complete_date == null) {
            e.job_complete_date = "";
          }
          //console.log(e);
          const follow_up_report_ref = firebase.firestore().collection("follow_up_reports").doc(e.id);
          follow_up_report_ref.set(e, {merge: true});
        })
      });
    },
    sendOverdueReminder() {
      var sales = {};
      firebase.firestore().collection("follow_up_reports")
      .get().then((collection) => {
        var rows = collection.docs.map(doc => doc.data());
        rows.forEach((e) => {
          if(e.job_complete_date == "" && new Date() > new Date(e.contract_due_date) && e.follower_info) {
            if (sales[e.follower_info.name] == null) {
              sales[e.follower_info.name] = {};
            }
            if (sales[e.follower_info.name].email == null) {
              sales[e.follower_info.name].email = e.follower_info.email;
            }
            if (sales[e.follower_info.name].overdueOrders == null) {
              sales[e.follower_info.name].overdueOrders = [];
            } else {
              sales[e.follower_info.name].overdueOrders.push({invoiceNo: e.invoice_number, dueDate: e.contract_due_date});
            }

            // const email = {
            //   to: [e.follower_info.email],
            //   message: {
            //     subject: '[Follow Up Report]' + e.invoice_number + ' needs to be updated - task is overdue',
            //     text: 'Hi ' + e.follower_info.name + ', \n\n' +
            //     'The details of the follow up report are as follows:\n' +
            //     'Invoice #: ' + e.invoice_number + '\n' +
            //     'Due date: ' + e.contract_due_date
            //   }
            // }
            // // firebase.firestore().collection('mail').add(email);
            // console.log(e.contract_due_date +  ' - ' + email.message.subject);
            // counter++;
            // console.log(counter);
          }
        });

        
        for (var s in sales) {
          const e = sales[s];
          var email = {
            to: [e.email, 'rick@johnstonemart.com'],
            message: {
              subject: '[Follow Up Report] Overdue tasks(' + e.overdueOrders.length + ') need to be updated.（no reply）',
              text: 'Hi ' + s + ', \n\n' +
              'The follow up reports below need to be updated:\n'
            }
          }
          for (var i = 0; i < e.overdueOrders.length; i++) {
            email.message.text += 'Invoice #: ' + e.overdueOrders[i].invoiceNo + '\t' + 'Due date: ' + e.overdueOrders[i].dueDate + '\n'
          }
          firebase.firestore().collection('mail').add(email);
          // console.log(email);
        }
      });
    },
    sendFollowUpReminder() {
      var sales = {};
      var email = null;
      var number_of_emails = 0;
      firebase.firestore().collection("follow_up_reports")
      .get().then((collection) => {
        var rows = collection.docs.map(doc => doc.data());
        rows.forEach((e) => {
          if (e.follower_info != null && e.job_complete_date.length < 1) {
            let last_modification_date = e.edit_histories[e.edit_histories.length - 1].edit_on;
            let today = new Date();
            let days_difference = Math.round((today.getTime() - new Date(last_modification_date).getTime()) / (1000 * 3600 *24));
            let invoice_days_difference = Math.round((today.getTime() - new Date(e.contract_signed_date).getTime()) / (1000 * 3600 *24));
            if (e.contract_due_date != "") {
              let due_days_difference = Math.round((new Date(e.contract_due_date).getTime() - today.getTime()) / (1000 * 3600 *24));
              
              if (due_days_difference < 0) {
                email = {
                  to: [e.follower_info.email],
                  message: {
                    subject: '[Follow Up Report]' + e.invoice_number + ' is overdue.',
                    text: 'Hi ' + e.follower_info.name + ', \n' +
                    'This order is overdue for ' + (-due_days_difference) + ' days.'
                  }
                }

                // firebase.firestore().collection('mail').add(email);
                number_of_emails++;
                if (sales[e.follower_info.name] == null) {
                  sales[e.follower_info.name] = {};
                }
                if (sales[e.follower_info.name].email == null) {
                  sales[e.follower_info.name].email = e.follower_info.email;
                }
                if (sales[e.follower_info.name].emails == null) {
                  sales[e.follower_info.name].emails = [];
                } else {
                  sales[e.follower_info.name].emails.push(email);
                }
                
                // console.log(email.message.subject);
                return;
              }

              if (due_days_difference < 28 && e.foundation_not_required != 'true' && e.foundation_done_date == "") {
                email = {
                  to: [e.follower_info.email],
                  message: {
                    subject: '[Follow Up Report]' + e.invoice_number + ' - foundation done date needs to be updated.',
                    text: 'Hi ' + e.follower_info.name + ', \n' +
                    'The foundation ordered date needs to be updated within 8 weeks before contract due date. This action is overdue for ' + (due_days_difference - 28) + ' days.'
                  }
                }

                // firebase.firestore().collection('mail').add(email);
                number_of_emails++;
                if (sales[e.follower_info.name] == null) {
                  sales[e.follower_info.name] = {};
                }
                if (sales[e.follower_info.name].emails == null) {
                  sales[e.follower_info.name].emails = [];
                } else {
                  sales[e.follower_info.name].emails.push(email);
                }
                // console.log(email.message.subject);
                return;
              } 
              
              if (due_days_difference < 56 && e.foundation_not_required != 'true' && e.foundation_ordered_date == "") {
                email = {
                  to: [e.follower_info.email],
                  message: {
                    subject: '[Follow Up Report]' + e.invoice_number + ' - foundation ordered date needs to be updated.',
                    text: 'Hi ' + e.follower_info.name + ', \n' +
                    'The foundation ordered date needs to be updated within 8 weeks before contract due date. This action is overdue for ' + (due_days_difference - 56) + ' days.'
                  }
                }

                // firebase.firestore().collection('mail').add(email);
                number_of_emails++;
                if (sales[e.follower_info.name] == null) {
                  sales[e.follower_info.name] = {};
                }
                if (sales[e.follower_info.name].emails == null) {
                  sales[e.follower_info.name].emails = [];
                } else {
                  sales[e.follower_info.name].emails.push(email);
                }
                // console.log(email.message.subject);
                return;
              }
            }
            if (invoice_days_difference > 28 && e.stone_order_not_required != 'true' && e.order_placed_date == "") {
              email = {
                to: [e.follower_info.email],
                message: {
                  subject: '[Follow Up Report]' + e.invoice_number + ' - stone ordered date needs to be updated. ',
                  text: 'Hi ' + e.follower_info.name + ', \n' +
                  'The stone ordered date needs to be updated within 4 weeks starting from the contract signed date, but has not been updated for ' + invoice_days_difference + ' days'
                }
              }

              // firebase.firestore().collection('mail').add(email);
              number_of_emails++;
              if (sales[e.follower_info.name] == null) {
                sales[e.follower_info.name] = {};
              }
              if (sales[e.follower_info.name].emails == null) {
                sales[e.follower_info.name].emails = [];
              } else {
                sales[e.follower_info.name].emails.push(email);
              }
              // console.log(e.follower_info.name + ': '+ email.message.subject + invoice_days_difference);
              return;
            }
            if (days_difference >= 28) {
              // var email = {
              //   to: [e.follower_info.email],
              //   message: {
              //     subject: 'A follow up report needs to be updated - ' + e.invoice_number,
              //     text: 'Hi ' + e.follower_info.name + ', \n' +
              //     'The details of the follow up report are as follows:\n' +
              //     'Invoice #: ' + e.invoice_number + '\n'
              //   }
              // }

              // firebase.firestore().collection('mail').add(email);

              // firebase.firestore().collection("follow_up_reports").doc(e.id)
              //   .set(
              //     {reminded: true},
              //     {merge: true}
              //   )
              //   .then(() => {
              //     console.log(e.invoice_number + ' is Reminded.');
              //   });
            }
          }
        })
        console.log(number_of_emails);
        console.log(sales);
      });
    },
  }
}
</script>

<style>
.pointer {
  cursor: pointer;
}
</style>